var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import axios from "axios";
import BulmaField from "./BulmaField";
const BulmaFieldComponent = Vue.extend(BulmaField);
export default {
    name: "PasswordChangeModal",
    components: { BulmaField },
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        changeUrl: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        'fields': {
            'old_password': new BulmaFieldComponent({ propsData: { 'label': 'Old Password', 'icon': 'fas fa-lock', 'labelWidth': '9rem' }, }),
            'new_password2': new BulmaFieldComponent({ propsData: { 'label': 'New Password', 'icon': 'fas fa-key', 'labelWidth': '9rem' }, }),
            'new_password1': new BulmaFieldComponent({ propsData: { 'label': 'Confirm Password', 'icon': 'fas fa-key', 'labelWidth': '9rem' }, }),
        },
        'sent': false,
        'countdownRemaining': 5,
        'countdownPointer': null,
    }),
    mounted() {
        for (let field_id in this.fields) {
            this.fields[field_id].$mount();
        }
    },
    methods: {
        submit: function () {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let response = yield axios.post(this.changeUrl, {
                        'old_password': this.fields.old_password.value,
                        'new_password1': this.fields.new_password1.value,
                        'new_password2': this.fields.new_password2.value,
                    });
                    this.sent = true;
                    this.startCountdown();
                }
                catch (e) {
                    if (e && e.response && e.response.data && typeof (e.response.data) === 'object') {
                        let errorFields = e.response.data;
                        for (let field_id in errorFields) {
                            // noinspection JSUnfilteredForInLoop
                            let field = this.fields[field_id];
                            if (!field) {
                                continue;
                            }
                            // noinspection JSUnfilteredForInLoop
                            field.error = errorFields[field_id].join('\n');
                        }
                    }
                }
            });
        },
        close() {
            this.$emit('update:active', false);
        },
        logout() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.$store.dispatch('user/logout');
                this.$router.push({ name: 'home' });
            });
        },
        startCountdown() {
            this.countdownPointer = setInterval(() => {
                this.countdownRemaining -= 1;
                if (this.countdownRemaining <= 0) {
                    this.stopCountdown();
                    this.logout();
                }
            }, 1000);
        },
        stopCountdown() {
            if (this.countdownPointer) {
                clearInterval(this.countdownPointer);
            }
        },
    },
    watch: {
        //Append the fields whenever the modal is rendered
        active(value) {
            if (value) {
                //Wait for re-render for the refs to exist
                this.$nextTick(() => {
                    console.log(this.$refs);
                    for (let field_id in this.fields) {
                        this.$refs.form.appendChild(this.fields[field_id].$el);
                    }
                });
            }
        }
    },
};
